import { Avatar, type AvatarProps } from "@/components/ui/Avatar";

export default function UserAvatar({
  className,
  color,
  size,
  isBordered,
  name,
  src,
}: UserAvatarProps) {
  const showFallback = !src;

  return (
    <Avatar
      src={src}
      name={name}
      showFallback={showFallback}
      color={color}
      size={size}
      className={className}
      isBordered={isBordered}
      getInitials={getInitials}
    />
  );
}

/** return the first letter of each word */
function getInitials(name: string) {
  return name
    .split(" ")
    .map((word) => word[0])
    .join("");
}

interface UserAvatarProps {
  className?: string;
  color?: AvatarProps["color"];
  size?: AvatarProps["size"];
  isBordered?: boolean;
  name?: string;
  src?: string;
}
